import React, { useState } from "react";
import "../css/PrincipalMessage.css";

const PrincipalMessage = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openVideoPopup = () => setIsOpen(true);
  const closeVideoPopup = () => setIsOpen(false);

  return (
    <section className="principal-section">
      <div className="principal-container">
        {}
        <div className="profile-card-wrapper" onClick={openVideoPopup}>
          <div className="profile-card">
            {}
            <div className="video-thumbnail-container">
              <img
                src="../images/principal.jpg"
                alt="Mr. Caesar D'silva - Principal GIIS Ahmedabad"
                className="thumbnail-img"
              />
              {}
              <div className="school-mini-logo"></div>
            </div>

            {}
            <div className="profile-overlay-meta">
              <h3 className="principal-name">Mr. Ghufran Ahmad Shakir</h3>
              <p className="principal-designation">
                Principal, Sahara Public Secondary School
              </p>

              {}
             <button
  className="global-btn"
  type="button"
  onClick={(e) => {
    e.stopPropagation();
    openVideoPopup();
  }}
>
  <span className="play-icon">▶</span> WATCH VIDEO
</button>
            </div>
          </div>
        </div>

        {}
        <div className="biography-wrapper">
          <p className="biography-text">
            Mr. Ghufran Ahmad Shakir, Principal of Sahara Public Secondary
            School, brings over 25 years of experience in school leadership and
            academic development. He has mentored students and educators across
            leading SEEB institutions, with a strong focus on quality learning
            and student success.
          </p>
        </div>
      </div>

      {}
      {isOpen && (
        <div className="video-popup-overlay" onClick={closeVideoPopup}>
          <div
            className="popup-content-block"
            onClick={(e) => e.stopPropagation()}
          >
            {}
           <button
  className="video-close-btn"
  onClick={closeVideoPopup}
  aria-label="Close video"
>
  &times;
</button>

            {}
            <div className="video-player-aspect-wrapper">
              <iframe
                src="https://www.youtube.com/embed/YzW0sXBJPEM?autoplay=1"
                title="Principal Message Video Player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default PrincipalMessage;
